/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import { handleUploadChange } from '../../helpers/imageUploadRemove';
import ErrorMessage from '../../components/ErrorMessageDisplay';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import { cdnURL } from '../../config';
import FileLoader from '../../components/FileLoader';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import IdentificationHeader from './IdentificationHeader';
import { dataService } from '../../services/data.service';
import ApplicationContext from '../../context/ApplicationContext';
import BackButton from '../../components/Button/BackButton';
import NextButton from '../../components/Button/NextButton';
import { identificationLanguageContent } from './IdentificationLanguageContent';

function UploadPhoto(props) {
    const { setIdCardData, idCardData, handlePage, sessionData, selectedLanguage } = useContext(ApplicationContext);
    const [fileName, setFileName] = useState('');
    const [idCardImage, setidCardImage] = useState('');
    const [imageError, setImageError] = useState('');
    const [imageLoading, setImageLoading] = useState(false);
    const [tempImage, setTempImage] = useState('');
    const [loading, setLoading] = useState(false);

    const updatePhoto = (val) => {
        const payload = {
            "card_image": val || '',
            'upload_type': 'upload',
            'process_ocr': false
        }
        if(val !== idCardData.card_image || !idCardData.card_issuer) {
            payload['process_ocr'] = true;
        }
        dataService.updateIDDetails(sessionStorage.getItem('session'), payload).then((res) => {
            if(res.error) {
                alert(res.message)
            } else {
                setImageLoading(false);
            }
        })
    }

    const handleUploadPhoto = (e) => {
        if(e.target.files) {
            setImageLoading(true);
            setFileName(e.target.files[0].name)
            handleUploadChange(e, setImageError, setImageLoading, 0, 0, 5242880, '5MB', '', ['image/png', 'image/jpg', 'image/jpeg'], 'patients/id-upload', setTempImage, setidCardImage, true, updatePhoto, 'front');
        }
    }

    const getIdentityCardDetails = () => {
        setImageLoading(true);
        dataService.getIDCardDetails(sessionStorage.getItem('session')).then((res) => {
            if(res.error === false) {
                setIdCardData(res.data.data);
                if(res.data.data.card_image) {
                    const file = res.data.data.card_image.split('/');
                    setFileName(file[1].includes('id-upload') ? file[2] : '');
                    setidCardImage(file[1].includes('id-upload') ? res.data.data.card_image : '');
                    setTempImage(file[1].includes('id-upload') ? `https://${cdnURL}/${res.data.data.card_image}` : '');
                    setImageLoading(false);
                } else {
                    setImageLoading(false);
                }
            } else {
                setImageLoading(false);
            }
        })
    }

    useEffect(() => {
        getIdentityCardDetails();
    }, []);

    const handleSubmitImage = () => {
        handlePage('card_details', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
    }
    
    const handleBack = () => {
        handlePage('upload_id_choice', '', '', sessionData['review'] === 'previous' ? 'previous' : '');
    }

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-auto'>
            <IdentificationHeader />
            <div className='p-[8px] overflow-x-hidden overflow-y-auto options-height Form-scroll mt-[18px] '>
                <div className='mx-[12px] '>
                    <div>
                        {identificationLanguageContent['identity-front-upload'][selectedLanguage]}
                        <div className={`'mt-[32px]' ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>
                            <p className={`text-sm font-normal text-[#333] capitalize ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>{(identificationLanguageContent['identification'][selectedLanguage]).toLowerCase()}
                                <b className='text-primary uppercase'> {identificationLanguageContent['front'][selectedLanguage]}</b></p>
                            <div className={`mt-1 border ${imageError === '' ? 'border-[#797979]' : 'border-[#B51803]'} rounded h-[40px] flex justify-between`}>
                                <p className='py-[10px] px-[12px] text-sm text-[#333] font-normal text-truncate'>{idCardImage === '' ? '' : fileName}</p>
                                <button className='bg-[#D7D7D7] p-[8px] text-[#797979] font-semibold w-fit uppercase'>
                                    {identificationLanguageContent['browse'][selectedLanguage]}
                                </button>
                                <input data-testid="browse_file" accept='.png, .jpeg, .jpg' type='file' className={`h-[39px] absolute w-[77px] ${selectedLanguage === 'ar' ? 'left-[15px]' : 'right-[13px]'} opacity-0`}
                                    onChange={(e) => {setidCardImage(''); handleUploadPhoto(e)}} />
                            </div>
                            {imageError && <ErrorMessage text={imageError} />}
                            <p className='text-[#797979] font-normal text-sm mt-1'>{identificationLanguageContent['file-format'][selectedLanguage]}</p>
                            {idCardImage !== '' && <div className='mt-[42px] mx-[20px] flex justify-center h-[174px]'>
                                <AnimatedImage url={tempImage} alt="id-card" />
                            </div>}
                            {imageLoading &&
                            <div className='mt-[60px] mx-[20px] flex justify-center h-[174px]'>
                                <FileLoader />
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex mb-[24px] justify-between mx-[16px] w-auto fold-gap pt-[20px] gap-[12px]'>
                <BackButton disabled={loading || imageLoading} handleClick={() => handleBack()} backType="previous" />
                <NextButton disabled={idCardImage === '' || loading} handleClick={() => handleSubmitImage()}   loader={loading} />
            </div>
        </AnimatedPageFade>
    );
}

export default UploadPhoto;